import { EventModel } from "@bryntum/schedulerpro";
import { PlanViewModelMixin } from "./mixins/PlanViewModelMixin";

const EventMixin = Target => class EventMixin extends Target {
  static get $name() {
    return "EventMixin";
  }

  static get fields() {
    return [
      { name: "taskId", dataSource: "task" },
      { name: "startDate", dataSource: "start_time" },
      { name: "endDate", dataSource: "end_time" },
      { name: "duration", persist: false },
      { name: "durationUnit", defaultValue: "hour", persist: false },
      { name: "calendar", persist: false },
      { name: "effort", persist: false },
      { name: "direction", persist: false },
      { name: "order"},
      // Constraint fields are not handled by the backend, disable them
      { name: "constraintDate", persist: false },
      { name: "constraintType", persist: false },
      { name: "name", persist: false },
      { name: "phone", persist: false },
      { name: "isPlanningDateEvent", persist: false },
      { name: "planningDateId", persist: false },
      { name: "archived", type: "boolean", defaultValue: false },
    ];
  }
}
export class Event extends EventMixin(EventModel) {
  static get $name() {
    return "Event";
  }

  get task() {
    return this.project?.extraTaskStore?.getById(this.taskId);
  }

  set task(recordOrId) {
    this.taskId = recordOrId?.id ?? recordOrId;
  }

  get name() {
    return this.task?.name || '';
  }

  set name(value) {
    // this statement would actually change model data and should
    // trigger view update
    this.set("name", value);
  }

  // Todo: Remove this as this is no longer being used
  get phone(){
    return this.resource?.phone;
  }

  get resourceDescription() {
    return this.resource?.description;
  }
}

export class PlanEvent extends EventMixin(PlanViewModelMixin(EventModel)) {
  static get $name() {
    return "PlanEvent";
  }

  static get fields() {
    return [
      { name: "_taskEventResources", persist: false }
    ];
  }

  get task() {
    return this.resource; // For plan events their 'tasks' is their 'resource'
  }

  set task(recordOrId) {
    this.taskId = recordOrId?.id ?? recordOrId;
  }

  get name() {
    return this.get("isPlanningDateEvent") ? this.get("name") : (this.task?.name || '');
  }

  set name(value) {
    // this statement would actually change model data and should
    // trigger view update
    this.set("name", value);
  }

  /**
   * Returns resources assigned to the given task event
   * @returns {ResourceModel[]}
   */
  get taskEventResources() {
    const { _taskEventResources, swivuProject: { resourceStore } } = this;

    // getById uses id map, so lookup won't be expensive
    return _taskEventResources?.map(id => resourceStore.getById(id)) || [];
  }

  set taskEventResources(value) {
    this.set('_taskEventResources', value.map(r => r.id));
  }

  resetTaskEventResource() {
    // this._taskEventResourcesCached = false;
  }
}
